import React, {Component} from 'react';
import {resetPassword, resetPasswordForgot} from '../services/UsersService';
import {Alert, Button, Form, Icon, Input, message, Steps} from 'antd';
import {Link} from "react-router-dom";

const FormItem = Form.Item;

const validator = require("email-validator");

class PasswordRecover extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            isLoading: false
        }
    }

    render() {
        const RecoverForm = Form.create()(PasswordRecoverForm);
        return <RecoverForm/>;
    }
}

class PasswordRecoverForm extends Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            step: 0
        }
    }

    emailValidator = (rule, value, callback) => {
        if (value && !validator.validate(value)) {
            callback("error");
        }
        callback();
    };

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            isLoading: true
        });
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const formRequest = Object.assign({}, values);
                if (this.state.step === 0) {
                    resetPasswordForgot(formRequest.email)
                        .then(response => {
                            this.setState({
                                step: 1,
                                email: formRequest.email,
                                isLoading: false
                            });
                        }).catch(error => {
                        this.setState({
                            isLoading: false
                        });
                    });
                }
                if (this.state.step === 1) {
                    resetPassword(this.state.email, formRequest.code)
                        .then(response => {
                            this.setState({
                                step: 2,
                                isLoading: false
                            });
                        }).catch(error => {
                        message.error('El código no es correcto o ha expirado');
                        this.setState({
                            isLoading: false
                        });
                    });
                }
            } else {
                this.setState({
                    isLoading: false
                });
            }
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div>
                <Steps current={this.state.step}>
                    <Steps.Step title="Correo electrónico" description="Recibir código de confirmación"/>
                    <Steps.Step title="Código de confirmación" description="Validación del código recibido"/>
                    <Steps.Step title="Fin" description="Nueva contraseña generada"/>
                </Steps>
                <div className="login-container">
                    <h1 className="page-title">Recuperar contraseña</h1>
                    <div className="login-content">
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            {
                                this.state.step === 0 ?
                                    <Form.Item>
                                        {getFieldDecorator('email', {
                                            initialValue: '',
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Este campo es obligatorio'
                                                },
                                                {
                                                    validator: this.emailValidator,
                                                    message: 'Correo electrónico inválido'
                                                }
                                            ],
                                        })(
                                            <Input prefix={<Icon type="mail"/>} size="large" type="mail"
                                                   placeholder={'Correo electrónico'}/>
                                        )}
                                    </Form.Item> : null
                            }
                            {
                                this.state.step === 1 ?
                                    <Form.Item>
                                        {getFieldDecorator('code', {
                                            initialValue: '',
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Este campo es obligatorio'
                                                }
                                            ],
                                        })(
                                            <Input prefix={<Icon type="code"/>} size="large" type="tel"
                                                   placeholder={'Código de validación'}/>
                                        )}
                                    </Form.Item> : null
                            }
                            {
                                this.state.step === 2 ?
                                    <Form.Item>
                                        <Alert
                                            message="Listo!"
                                            description="Se le ha generado y enviado una nueva contraseña a su correo electrónico"
                                            type="info"
                                        />
                                        <h3>
                                            <Link to={'/'}> {'Regresar al inicio'}</Link>
                                        </h3>
                                    </Form.Item> : null
                            }
                            {
                                this.state.step < 2 ?
                                    <FormItem>
                                        <Button type="primary" htmlType="submit" size="large"
                                                className="login-form-button"
                                                icon="right" loading={this.state && this.state.isLoading}>
                                            {this.state.step === 0 ? 'Enviar' : 'Validar'}
                                        </Button>
                                    </FormItem> : null
                            }
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default PasswordRecover;


// WEBPACK FOOTER //
// ./src/app/views/PasswordRecover.js